import {configureStore} from "@reduxjs/toolkit";
import routeReducer from "@store/route.slice";
import wordpressReducer from "@store/wordpress.slice";
import preferencesReducer from "@store/preferences.slice";
import {api, apiShowError} from '@services/Api'
import {wordpressApi} from '@services/WordpressAdmin'
import {loadState, saveState} from "@store/localStorage";

const preloadedState = loadState();

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [wordpressApi.reducerPath]: wordpressApi.reducer,
    routes: routeReducer,
    wordpress: wordpressReducer,
    preferences: preferencesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    })
        .concat(api.middleware)
        .concat(wordpressApi.middleware)
        .concat([apiShowError]),
  preloadedState,
});

store.subscribe(() => {
    saveState({
        preferences:store.getState().preferences,
    });
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
// setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
